import dayjs from "dayjs"
import weekOfYear from "dayjs/plugin/weekOfYear"
import isLeapYear from "dayjs/plugin/isLeapYear"

dayjs.extend(weekOfYear)
dayjs.extend(isLeapYear)

export function checkTargetGroupsValidity(storedTargets, startDate) {
    // check if the target groups are valid for the chosen period
    // if not, add an error message

    const newTargetGroupsValidFrom = new Date("2024-12-30")
    const oldAgeGroupsFrom = ["3", "15", "30", "45", "60"]
    const oldAgeGroupsTo = ["14", "29", "44", "59", "99"]
    const oldGender = ["all"]
    let errors = []

    // get the first date in the chosen period
    const firstDateInChosenPeriod = new Date(startDate)

    // check if the first date in the chosen period is before the valid from date of the new target groups
    if (firstDateInChosenPeriod < newTargetGroupsValidFrom) {
        let targetGroupsNotValid = []
        // check if there are any target groups that are not valid
        for (let i = 0; i < storedTargets.length; i++) {
            if (!oldAgeGroupsFrom.includes(storedTargets[i].age_from) || !oldAgeGroupsTo.includes(storedTargets[i].age_to) || !oldGender.includes(storedTargets[i].group)) {
                targetGroupsNotValid.push(storedTargets[i].selectedMeasureText.subHeader.split(" ")[0])
            }
        }
        if (targetGroupsNotValid.length > 0) {
            errors.push("The following target groups are not available before " + newTargetGroupsValidFrom.toISOString().split("T")[0] + ", remove these or select a new period.")
            // add the list of target groups that are not valid
            errors.push(targetGroupsNotValid.join(", "))
        }
    }
    return errors
}

export const transformToGenresFromAPIResponse = genres => ({
    config: {
        genres: [...genres],
    },
})
/*

Store helpers


*/
export function setLevelOneValuesForPrograms(levelOne, levelTwo, columns) {
    levelTwo.sort((a, b) => (a.providerName > b.providerName ? 1 : b.providerName > a.providerName ? -1 : 0))
    //styling for sites and moving data from and to lvl2/lvl1
    if (levelTwo.length === 1) {
        if (levelTwo[0].providerGroup == "Sites") {
            levelTwo[0].providerNameVhtml = `<span style="color: #337ab7; font-weight: bold;">${levelTwo[0].providerName}</span>`
        }
    } else {
        //for each lvl2 find providerName/providerGroup pairs
        let providerGroupsNamePairs = levelTwo.reduce((all, p) => {
            if (p.providerGroup !== "Sites") {
                let providerNames = []
                if (all[p.providerGroup]) providerNames = all[p.providerGroup]
                if (!providerNames.includes(p.providerName)) {
                    providerNames.push(p.providerName)
                    all[p.providerGroup] = providerNames
                }
            } else all[p.providerGroup] = p.providerName
            return all
        }, {})
        if (providerGroupsNamePairs?.Sites != undefined) {
            providerGroupsNamePairs.Sites = `<span style="color: #337ab7; font-weight: bold;">${providerGroupsNamePairs.Sites}</span>`
        }
        let providerNameParent = []
        for (const property in providerGroupsNamePairs) {
            let isArray = Array.isArray(providerGroupsNamePairs[property])
            if (isArray) {
                providerNameParent = providerNameParent.concat(providerGroupsNamePairs[property])
                if (providerGroupsNamePairs.Sites) providerNameParent.push(providerGroupsNamePairs.Sites)
            }
        }
        providerNameParent.sort(function(a, b) {
            //remove html for sorting
            a = a.replace(/<[^>]*>?/gm, "")
            b = b.replace(/<[^>]*>?/gm, "")
            if (a < b) {
                return -1
            }
            if (b > a) {
                return 1
            }
            return 0
        })
        levelOne.providerNameArray = []
        providerNameParent = providerNameParent.filter(p => p)
        if (providerGroupsNamePairs.Sites != undefined) levelOne.providerNameVhtml = providerNameParent.join(", ")
        levelOne.providerName = providerNameParent.map(p => p.replace(/<[^>]*>?/gm, "")).join(", ")
        for (const l2 of levelTwo) {
            if (l2.providerGroup == "Sites") {
                l2.providerNameVhtml = `<span style="color: #337ab7; font-weight: bold;">${l2.providerName}</span>`
            }
        }
    }
    for (let i = 0; i < columns.length; i++) {
        //for each selected column (measures excluded)
        let columnValues = levelTwo.map(obj => obj[columns[i]]).filter(item => item.trim())
        if (new Set(columnValues).size === 1) {
            if (!levelOne[columns[i]]) levelOne[columns[i]] = columnValues[0]
        }
    }
    //if there is a start time, set the earliest start time on the parent
    // Regular expression to match time formats (HH:MM)
    const timeRegex = /\b([01]?[0-9]|2[0-3]):[0-5][0-9]\b/g
    let allChildrenTimes = levelTwo
        .map(p => p.time)
        .reduce((times, str) => {
            const matches = str.match(timeRegex)
            if (matches) {
                times.push(...matches)
            }
            return times
        }, [])
    let earliestTime = findEarliestTime(allChildrenTimes)
    levelOne.time = earliestTime
    levelOne.providerGroup = levelTwo.map(lvl2 => lvl2.providerGroup).find(lvl2 => lvl2 !== "Sites")
    let lvl2Tv = levelTwo.filter(lvl2 => lvl2.providerGroup !== "Sites")
    if (lvl2Tv.length > 0) levelOne.date = lvl2Tv.reduce((min, item) => (new Date(item.date) < new Date(min.date) ? item : min)).date
}
function findEarliestTime(times) {
    if (times.length === 0) return null

    let earliestTime = times[0]
    let earliestMinutes = timeToMinutes(earliestTime)

    for (let i = 1; i < times.length; i++) {
        const currentMinutes = timeToMinutes(times[i])
        if (currentMinutes < earliestMinutes) {
            earliestMinutes = currentMinutes
            earliestTime = times[i]
        }
    }

    return earliestTime
}
export function toMinutesAfterMidnight(timeStr) {
    let minutesAfterMidnight = ""
    const startHours = parseInt(timeStr[0].slice(0, 2), 10);
    const startMinutes = parseInt(timeStr[0].slice(2), 10);
    let endDateExist = timeStr[1] ? true : false;
    if(!endDateExist) {
        minutesAfterMidnight = `${startHours * 60 + startMinutes}`
    }
    else {
        const endHours = parseInt(timeStr[1].slice(0, 2), 10);
        const endMinutes = parseInt(timeStr[1].slice(2), 10);
        minutesAfterMidnight = `${startHours * 60 + startMinutes}-${endHours * 60 + endMinutes}`;
    }
    return minutesAfterMidnight
}
function timeToMinutes(time) {
    const [hours, minutes] = time.split(":").map(Number)
    return hours * 60 + minutes
}
export function setLevelOneValuesForAds(levelOne, levelTwo, columns) {
    if (levelTwo !== null) {
        levelTwo.sort((a, b) => (a.providerName > b.providerName ? 1 : b.providerName > a.providerName ? -1 : 0))
    }
    //styling for sites and moving data from and to lvl2/lvl1
    if (levelTwo?.length === 1) {
        if (levelTwo[0].providerGroup == "Sites") {
            levelTwo[0].providerNameVhtml = `<span style="color: #337ab7; font-weight: bold;">${levelTwo[0].providerName}</span>`
        }
    } else {
        levelOne.providerName = [...new Set(levelTwo.map(p => p.siteName))].sort().join(", ")
        for (const l2 of levelTwo) {
            if (l2.providerGroup == "Sites") {
                l2.providerNameVhtml = `<span style="color: #337ab7; font-weight: bold;">${l2.providerName}</span>`
            }
        }
    }
    // group all providerkeys in level2 into an array in level 1, add new attribute providerKeys
    levelOne.providerKeys = levelTwo.map(x => x.providerKey)

    for (let i = 0; i < columns.length; i++) {
        //for each selected column (measures excluded)
        let columnValues = levelTwo.map(obj => obj[columns[i]]).filter(item => item.trim())
        if (new Set(columnValues).size === 1) {
            if (!levelOne[columns[i]]) levelOne[columns[i]] = columnValues[0]
        }
    }
}
export function setLevelOneValuesForChannels(levelOne, levelTwo) {
    levelTwo.sort((a, b) => (a.providerName.toLowerCase() > b.providerName.toLowerCase() ? 1 : b.providerName.toLowerCase() > a.providerName.toLowerCase() ? -1 : 0))
    //if all category values are same write it on the parent category
    if (levelTwo.map(lvl2 => lvl2.category).every((val, i, arr) => val === arr[0])) levelOne.category = levelTwo[0].category
    // .every( (val, i, arr) => val === arr[0] )
    //styling for sites and moving data from and to lvl2/lvl1
    if (levelTwo.length === 1 && levelTwo[0].category === "Site") {
        levelOne.providerNameVhtml = `<span style="color: #337ab7; font-weight: bold;">${levelTwo[0].providerName}</span>`
    }
    for (const l2 of levelTwo) {
        if (l2.category.toLowerCase() == "site") {
            l2.providerNameVhtml = `<span style="color: #337ab7; font-weight: bold;">${l2.providerName}</span>`
        }
    }
}
export function convertToRowkeysArraySite(sitearray) {
    let rowKeysArray = []
    for (let ic = 0; ic < sitearray.length; ic++) {
        if (sitearray[ic].chosen) {
            let rowKeysObject = {}
            rowKeysObject.date = sitearray[ic].date
            rowKeysObject.key = sitearray[ic].providerKey
            rowKeysArray.push(rowKeysObject)
        }
    }
    return rowKeysArray
}

export function createExportAdHeaders(getters, tab, messageExceededRecommendedPeriod, query) {
    let channelNames = Object.values(getters.getAdsProviders.channels).flat()
    let chosenChannels = channelNames
        .filter(c => query.providerKeys.includes(c.provider_key))
        .map(p => p.provider_name)
        .join(", ")
    let chosenSites = getters.getAdsProviders.sites
        .filter(s => query.providerKeys.includes(s.provider_key))
        .map(p => p.provider_name)
        .join(", ")
    let today = new Date()
    let buyingAgencies = getters.getAdsFormFields.buyingAgencies.selectlistitems
    let advertisers = getters.getAdsFormFields.advertisers.selectlistitems
    let products = getters.getAdsFormFields.products.selectlistitems
    let csvFormFields = [
        ["Analysis date", `${today.toISOString().split("T")[0]} ${today.getHours()}:${today.getMinutes()}`],
        ["Tool", getters.getApplicationHeader, tab == "list" ? "Ads, list tab" : "Ads, summary tab"],
        ["Version klient, API", getters.getClientVersion, getters.getApiVersion],
        ...(messageExceededRecommendedPeriod ? [[messageExceededRecommendedPeriod]] : [[]]),
        ["Consumption period", query.startDate, query.endDate],
        query.providerKeys.length > 0 && ["Channels", chosenChannels, chosenSites],
        query.filmCodes.length > 0 && ["Film codes", query.filmCodes.join(", ")],
        query.buyingAgency && ["Agency", buyingAgencies.find(b => b.id === query.buyingAgency).label],
        query.advertiser && ["Advertiser", advertisers.find(a => a.id === query.advertiser).label],
        query.product && ["Product", products.find(p => p.id === query.product).label],
    ].filter(Boolean)

    if (getters.getAdsUniverseSize.length > 0) {
        for (let i = 0; i < getters.getAdsUniverseSize.length; i++) {
            let splittedUniverseSize = getters.getAdsUniverseSize[i]
            splittedUniverseSize = splittedUniverseSize.replace(/\s/g, "").split(";")
            csvFormFields.push([i == 0 ? "Target groups" : "", splittedUniverseSize[0], splittedUniverseSize[1]])
        }
    }

    /*
    if (hasTvOrOnlineSource) {
        let measureIndex = exportInfo.itemsToExport.data.columns.findIndex(column => column.key.includes("measure"))
        if (getters.getAdsExportQuery.include_detail_rows) ++measureIndex
        let messageArray = new Array(measureIndex + 1).fill("")
        messageArray[measureIndex] = "* incoming parts, which are not currency, of tv- and online-data for calculation of total column"
        csvFormFields.push(messageArray)
    } else {
        csvFormFields.push([])
    }
    */
    return csvFormFields
}

export function createExportAdList(getters, exportInfo, messageExceededRecommendedPeriod) {
    let hasTvOrOnlineSource = false
    exportInfo.itemsToExport.data.columns.forEach(column => {
        if (column.key.includes("measure") && (column.label.includes("(tv-data)") || column.label.includes("(online-data)"))) {
            hasTvOrOnlineSource = true
            if (!column.label.endsWith("*")) {
                column.label += "*"
            }
        }
    })
    let csvArray = []
    if (getters.getAdsExportQuery.include_header) csvArray = csvArray.concat(getFormFieldsHeaderExportAdTab(getters, exportInfo, messageExceededRecommendedPeriod, hasTvOrOnlineSource))
    let resultHeader = [...exportInfo.itemsToExport.data.columns].filter(rh => rh.key != "plussign" && rh.key != "chosen")
    if (getters.getAdsExportQuery.include_detail_rows)
        resultHeader.unshift({
            label: "*/-",
            key: "asterix",
        })
    csvArray.push(resultHeader.map(rh => rh.label))
    let resultRows = []
    //add sum row
    let resultRow = []
    if (exportInfo.tab == "sum") {
        let sumRow = exportInfo.itemsToExport.data.totalRow
        for (let resultHeaderI = 0; resultHeaderI < resultHeader.length; resultHeaderI++) {
            let resultHeaderKey = resultHeader[resultHeaderI].key
            if (resultHeaderKey === "asterix") resultRow.push("")
            else resultRow.push(sumRow[resultHeaderKey])
        }
        resultRows.push(resultRow)
    }
    //add level one ads
    for (let lvlOneI = 0; lvlOneI < exportInfo.itemsToExport.data.levelOneAdsWithLevelTwoAds.length; lvlOneI++) {
        resultRow = []
        let lvlOneAd = exportInfo.itemsToExport.data.levelOneAdsWithLevelTwoAds[lvlOneI]
        for (let resultHeaderI = 0; resultHeaderI < resultHeader.length; resultHeaderI++) {
            let resultHeaderKey = resultHeader[resultHeaderI].key
            if (resultHeaderKey === "asterix" && lvlOneAd.levelTwoAds.length === 1) resultRow.push("")
            else if (resultHeaderKey === "asterix") resultRow.push("*")
            else resultRow.push(lvlOneAd[resultHeaderKey])
        }
        resultRows.push(resultRow)
        if (getters.getAdsExportQuery.include_detail_rows) {
            //add level two ads if levelonead has more than one child
            if (lvlOneAd.levelTwoAds.length > 1) {
                for (let lvlTwoI = 0; lvlTwoI < lvlOneAd.levelTwoAds.length; lvlTwoI++) {
                    resultRow = []
                    let levelTwoAd = lvlOneAd.levelTwoAds[lvlTwoI]
                    for (let resultHeaderLvlTwoI = 0; resultHeaderLvlTwoI < resultHeader.length; resultHeaderLvlTwoI++) {
                        let resultHeaderKey = resultHeader[resultHeaderLvlTwoI].key
                        if (resultHeaderKey === "asterix") resultRow.push("-")
                        else resultRow.push(levelTwoAd[resultHeaderKey])
                    }
                    resultRows.push(resultRow)
                }
            }
        }
    }
    csvArray = csvArray.concat(resultRows)
    let csv = arrayToCsv(csvArray)
    downloadBlob(csv, exportInfo.fileName, "text/csv;charset=utf-8;")
}
export function arrayToCsv(data) {
    return data
        .map(
            row =>
                row
                    .map(String) // convert every value to String
                    .map(v => v.replaceAll('"', '""')) // escape double colons
                    .map(v => `"${v}"`) // quote it
                    .join(";") // comma-separated
        )
        .join("\r\n") // rows starting on new lines
}
export function downloadBlob(content, filename, contentType) {
    // Create a blob
    var BOM = "\uFEFF"
    var blob = new Blob([`${BOM}${content}`], {
        type: contentType,
    })
    var url = URL.createObjectURL(blob)

    // Create a link to download it
    var pom = document.createElement("a")
    pom.href = url
    pom.setAttribute("download", filename)
    pom.click()
}
export function getHeaderProgramTab(context, tab, query) {
    let today = new Date()
    let channelNames = context.state.programsProviders.filter(p => p.provider_type == "CHANNEL" && p.exists_content)
    let siteNames = context.state.programsProviders.filter(p => p.provider_type == "SITE" && (p.exists_content || p.exists_site))
    let chosenChannels = channelNames
        .filter(p => query.provider_keys.includes(p.provider_key))
        .map(p => p.provider_name)
        .join(", ")
    let chosenSites = siteNames
        .filter(p => query.provider_keys.includes(p.provider_key))
        .map(p => p.provider_name)
        .join(", ")
    let chosenGenres = query.genres.genres ? query.genres.genres : []
    chosenGenres = chosenGenres
        .map(function(genre) {
            let mappedGenre = genre.genre1
            if (genre.genre2 && genre.genre2 != "-") mappedGenre += `: ${genre.genre2}`
            if (genre.genre3 && genre.genre3 != "-") mappedGenre += `: ${genre.genre3}`
            return mappedGenre
        })
        .join(" | ")
    return [
        ["Analysis date", `${today.toISOString().split("T")[0]} ${today.getHours()}:${today.getMinutes()}`],
        ["Tool", context.getters.getApplicationHeader, tab],
        ["Client version, API", context.getters.getClientVersion, context.getters.getApiVersion],
        ...[[]],
        ["Consumption period", query.start_date, query.end_date],
        query.showPubDate && ["Publication date", query.pub_start_date, query.pub_end_date],
        query.search_text && ["Search terms", query.search_text],
        query.provider_keys.length > 0 && ["Channels", chosenChannels, chosenSites],
        chosenGenres && ["Genre", chosenGenres],
        ["Show empty answers:", query.show_all_content_with_traffic_in_period ? "yes" : "no"],
    ].filter(Boolean)
}
export function getFormFieldsHeaderExportAdTab(getters, exportInfo, messageExceededRecommendedPeriod, hasTvOrOnlineSource) {
    let channelNames = Object.values(getters.getAdsProviders.channels).flat()
    let chosenChannels = channelNames
        .filter(c => getters.getAdsQueryForAPI.providerKeys.includes(c.provider_key))
        .map(p => p.provider_name)
        .join(", ")
    let chosenSites = getters.getAdsProviders.sites
        .filter(s => getters.getAdsQueryForAPI.providerKeys.includes(s.provider_key))
        .map(p => p.provider_name)
        .join(", ")
    let today = new Date()
    let buyingAgencies = getters.getAdsFormFields.buyingAgencies.selectlistitems
    let advertisers = getters.getAdsFormFields.advertisers.selectlistitems
    let products = getters.getAdsFormFields.products.selectlistitems
    let csvFormFields = [
        ["Analysis date", `${today.toISOString().split("T")[0]} ${today.getHours()}:${today.getMinutes()}`],
        ["Tool", getters.getApplicationHeader, exportInfo.tab == "list" ? "Ads, list tab" : "Ads, summary tab"],
        ["Client version, API", getters.getClientVersion, getters.getApiVersion],
        ...(messageExceededRecommendedPeriod ? [[messageExceededRecommendedPeriod]] : [[]]),
        ["Consumption period", getters.getAdsQueryForAPI.startDate, getters.getAdsQueryForAPI.endDate],
        getters.getAdsQueryForAPI.providerKeys.length > 0 && ["Channels", chosenChannels, chosenSites],
        getters.getAdsQueryForAPI.filmCodes.length > 0 && ["Film codes", getters.getAdsQueryForAPI.filmCodes.join(", ")],
        getters.getAdsQueryForAPI.buyingAgency && ["Agency", buyingAgencies.find(b => b.id === getters.getAdsQueryForAPI.buyingAgency).label],
        getters.getAdsQueryForAPI.advertiser && ["Advertiser", advertisers.find(a => a.id === getters.getAdsQueryForAPI.advertiser).label],
        getters.getAdsQueryForAPI.product && ["Product", products.find(p => p.id === getters.getAdsQueryForAPI.product).label],
    ].filter(Boolean)
    if (getters.getAdsUniverseSize.length > 0) {
        for (let i = 0; i < getters.getAdsUniverseSize.length; i++) {
            let splittedUniverseSize = getters.getAdsUniverseSize[i]
            splittedUniverseSize = splittedUniverseSize.replace(/\s/g, "").split(";")
            csvFormFields.push([i == 0 ? "Target groups" : "", splittedUniverseSize[0], splittedUniverseSize[1]])
        }
    }
    if (hasTvOrOnlineSource) {
        let measureIndex = exportInfo.itemsToExport.data.columns.findIndex(column => column.key.includes("measure"))
        if (getters.getAdsExportQuery.include_detail_rows) ++measureIndex
        let messageArray = new Array(measureIndex + 1).fill("")
        messageArray[measureIndex] = "* component parts, which are not currency, of TV and online data for calculation of total column"
        csvFormFields.push(messageArray)
    } else {
        csvFormFields.push([])
    }
    return csvFormFields
}
export function getHeaderChannelTab(context, tab, messageExceededRecommendedPeriod) {
    let today = new Date()
    let channelNames = context.state.channelsProviders.filter(p => p.provider_type == "CHANNEL" && p.exists_content)
    let siteNames = context.state.channelsProviders.filter(p => p.provider_type == "SITE" && (p.exists_content || p.exists_site))
    let chosenChannels = channelNames
        .filter(p => context.state.channelsExportQuery.provider_keys.includes(p.provider_key))
        .map(p => p.provider_name)
        .join(", ")
    let chosenSites = siteNames
        .filter(p => context.state.channelsExportQuery.provider_keys.includes(p.provider_key))
        .map(p => p.provider_name)
        .join(", ")
    return [
        ["Analysis date", `${today.toISOString().split("T")[0]} ${today.getHours()}:${today.getMinutes()}`],
        ["Tool", context.getters.getApplicationHeader, tab],
        ["Client version, API", context.getters.getClientVersion, context.getters.getApiVersion],
        ...(messageExceededRecommendedPeriod ? [[messageExceededRecommendedPeriod]] : [[]]),
        ["Consumption period", context.state.channelsExportQuery.start_date, context.state.channelsExportQuery.end_date],
        context.state.channelsExportQuery.provider_keys.length > 0 && ["Channels", chosenChannels, chosenSites],
    ].filter(Boolean)
}

// checks if a version in format ex. 1.44.5345 is less than the required version
export function isVersionLessThan(version, requiredVersion) {
    // if either version or requiredVersion is null or undefined, return false
    if (!version || !requiredVersion) {
        return false
    }

    const versionDots = (version.match(/\./g) || []).length
    const requiredVersionDots = (requiredVersion.match(/\./g) || []).length

    if (versionDots === requiredVersionDots) {
        // remove all non-numeric characters except the decimal point from the strings
        let v1parts = version.split(".").map(Number)
        let v2parts = requiredVersion.split(".").map(Number)

        // pad the shorter array with zeros
        while (v1parts.length < v2parts.length) v1parts.push(0)
        while (v2parts.length < v1parts.length) v2parts.push(0)

        for (let i = 0; i < v1parts.length; ++i) {
            if (v1parts[i] < v2parts[i]) {
                return true
            } else if (v1parts[i] > v2parts[i]) {
                return false
            }
        }

        // the versions are identical
        return false
    } else {
        // fallback, remove all non-numeric characters and the decimal point from the strings
        version = parseFloat(version.replace(/[^0-9]/g, ""))
        requiredVersion = parseFloat(requiredVersion.replace(/[^0-9]/g, ""))

        return version < requiredVersion
    }
}
// Checks for trp and reach mesures, and for unique target groups in the list query
// and adds appropriate additional measures for the campaign report
export function buildMeasureDataForCampaignReport(measures) {
    const sourceTypes = ["Tv", "Online", "Total"]
    const groupPrefix = {
        all: "A",
        female: "W",
        male: "M",
    }

    // Check for presence of trp and reach in measures
    const hasTrp = measures.some(m => m.measure === "trp")
    const hasReach = measures.some(m => m.measure === "reach")

    let allMeasures = [...measures]

    // Extract target groups from measures
    const targetGroups = measures.map(m => ({
        age_from: m.age_from,
        age_to: m.age_to,
        label: `${groupPrefix[m.group] || "A"}${m.age_from}-${m.age_to}`,
        group: m.group,
    }))

    // Removing duplicates
    const uniqueTargetGroups = Array.from(new Set(targetGroups.map(JSON.stringify))).map(JSON.parse)

    // Add measures (mirror reach and trp (if any trp) and add all sources)
    uniqueTargetGroups.forEach(({ age_from, age_to, group }) => {
        const targetLabel = `${groupPrefix[group]}${age_from}-${age_to}`
        sourceTypes.forEach(source => {
            const trpForSource = allMeasures.find(m => m.measure === "trp" && m.group === group && m.age_from === age_from && m.age_to === age_to && m.source === source)
            const reachForSource = allMeasures.find(m => m.measure === "reach" && m.group === group && m.age_from === age_from && m.age_to === age_to && m.source === source)

            if (!trpForSource) {
                allMeasures.push({
                    age_from: age_from,
                    age_to: age_to,
                    consolidation: { value: "-1", text: "KOperiod" },
                    group: group,
                    measure: "trp",
                    reach_online: "5",
                    reach_tv: "1",
                    selectedMeasureText: {
                        header: "TRP 000s",
                        subHeader: `${targetLabel} ${source === "Tv" ? "TV" : source}`,
                    },
                    source: source,
                })
            }

            if ((!reachForSource && (hasReach || hasTrp)) || (!hasTrp && !hasReach)) {
                allMeasures.push({
                    age_from: age_from,
                    age_to: age_to,
                    consolidation: { value: "-1", text: "KOperiod" },
                    group: group,
                    measure: "reach",
                    reach_online: "5",
                    reach_tv: "1",
                    selectedMeasureText: {
                        header: "Reach 000s",
                        subHeader: `${targetLabel} (1min & 5s/50%) ${source === "Tv" ? "TV" : source}`,
                    },
                    source: source,
                })
            }
        })
    })

    // Remove any measure that is not reach or trp from allMeasures
    allMeasures = allMeasures.filter(m => m.measure === "reach" || m.measure === "trp")

    // Sort target groups first by group, then by age_from, then by age_to
    uniqueTargetGroups.sort((a, b) => {
        // Sorting based on the 'group' attribute
        const groupOrder = ["all", "female", "male"]
        if (a.group !== b.group) {
            return groupOrder.indexOf(a.group) - groupOrder.indexOf(b.group)
        }

        // Sorting based on 'age_from' attribute
        if (a.age_from !== b.age_from) {
            return Number(a.age_from) - Number(b.age_from)
        }

        // Sorting based on 'age_to' attribute
        return Number(a.age_to) - Number(b.age_to)
    })

    // Sort measures by so that all trp measures comes first and then sort by group, then by age_from, then by age_to and last by source. source should be in order "TV", "Online" and lastly "Total"
    allMeasures.sort((a, b) => {
        // Sorting based on the 'measure' attribute
        if (a.measure !== b.measure) {
            return a.measure === "trp" ? -1 : 1
        }

        // Sorting based on the 'group' attribute
        if (a.group !== b.group) {
            return a.group.localeCompare(b.group)
        }

        // Sorting based on 'age_from' attribute
        if (a.age_from !== b.age_from) {
            return Number(a.age_from) - Number(b.age_from)
        }

        // Sorting based on 'age_to' attribute
        if (a.age_to !== b.age_to) {
            return Number(a.age_to) - Number(b.age_to)
        }

        // Sorting based on 'source' attribute
        const sourceOrder = ["Tv", "Online", "Total"]
        return sourceOrder.indexOf(a.source) - sourceOrder.indexOf(b.source)
    })
    return {
        measures: allMeasures,
        targetGroups: uniqueTargetGroups,
    }
}
// For adding strings representing swedish formatted numbers
export function addStringsAsNumbersSafe(strNum1, strNum2) {
    if (!strNum1 || strNum1.trim() === "") strNum1 = "0"
    if (!strNum2 || strNum2.trim() === "") strNum2 = "0"

    let num1 = parseFloat(strNum1.replace(",", "."))
    let num2 = parseFloat(strNum2.replace(",", "."))

    let sum = num1 + num2

    return sum.toFixed(1).replace(".", ",")
}

// Keeping these as they are usefull if we need to inform the user of partial weeks in Campaign report weekly view
// export function isFullWeekIncluded(weekNumber, year, dates) {
//     const startOfWeek = dayjs()
//         .year(year)
//         .week(weekNumber)
//         .startOf("week")

//     for (let i = 0; i < 7; i++) {
//         const currentDay = new Date(startOfWeek.add(i, "day").toISOString())
//         const foundDate = dates.find(date => date.getFullYear() === currentDay.getFullYear() && date.getMonth() === currentDay.getMonth() && date.getDate() === currentDay.getDate())

//         if (!foundDate) {
//             return false
//         }
//     }

//     return true
// }
// // Takes an array of date objects and an array of ads campaign report result data and filters out results where weeks are not complete
// export function getFullWeeks(dates, weekDataArray) {
//     return weekDataArray.filter(item => {
//         const [year, weekString] = item.yearWeek.split("/v")
//         const weekNumber = parseInt(weekString, 10)

//         if (!isNaN(weekNumber) && year) {
//             return isFullWeekIncluded(weekNumber, parseInt(year, 10), dates)
//         }

//         return false
//     })
// }

export function updateYearWeek(arr) {
    const currentYear = new Date().getFullYear()

    if (arr.length < 2) {
        if (arr[0].yearWeek.startsWith("/")) {
            arr[0].yearWeek = `${currentYear}${arr[0].yearWeek}` // Use the current year if arr has only one item and starts with "/"
        }
        return arr
    }

    if (arr[0].yearWeek && !arr[0].yearWeek.startsWith("/")) return arr

    const previousYear = parseInt(arr[1].yearWeek.split("/")[0])
    const previousWeek = parseInt(arr[1].yearWeek.split("/")[1].slice(1))
    const currentWeek = parseInt(arr[0].yearWeek.split("/")[1].slice(1))

    const inferredYear = currentWeek < previousWeek ? previousYear + 1 : previousYear

    arr[0].yearWeek = `${inferredYear}${arr[0].yearWeek}`

    return arr
}
export function sortItems(rows, sortBy, sortDesc) {
    return rows.sort((a, b) => {
        const aValue = getFieldValue(a[sortBy])
        const bValue = getFieldValue(b[sortBy])
        if (typeof aValue === "number" && typeof bValue === "number") {
            if (sortDesc) {
                return bValue - aValue
            } else {
                return aValue - bValue
            }
        } else {
            // If one of the values is not a number, sort them as strings
            if (sortDesc) {
                return bValue.toString().localeCompare(aValue.toString())
            } else {
                return aValue.toString().localeCompare(bValue.toString())
            }
        }
    })
}

function getFieldValue(value) {
    if (typeof value === "string" && value.includes(",")) {
        // If the value contains a comma, attempt to parse as float
        const floatValue = parseFloat(value.replace(",", ".")).toFixed(1)
        // If parsing is successful, return the float value, otherwise return the original string value
        return isNaN(floatValue) ? value : floatValue
    }
    // If the value is not a string with a comma, attempt to parse as float
    const floatValue = parseFloat(value).toFixed(1)
    // If parsing is successful, return the float value, otherwise return the original value
    return isNaN(floatValue) ? value : floatValue
}

export function replace000sOrPercent(inputString) {
    return inputString.slice(-4) === "000s" ? inputString.slice(0, -4) + "%" : inputString.slice(0, -1) + "000s"
}

export function convertDecimalCommaToPercentage(stringValue) {
    let value = parseFloat(stringValue.replace(",", "."))
    let displayValue = !isNaN(value) ? (value * 100).toFixed(1) : stringValue
    return displayValue.toString().replace(".", ",")
}
export function takeElementsUpTo200Chars(arr) {
    let totalChars = 0
    const resultArray = []

    for (let i = 0; i < arr.length; i++) {
        const currentLength = arr[i].length

        // Check if adding the next element exceeds 200 characters
        if (totalChars + currentLength > 200) {
            break // Stop iteration if adding the next element exceeds 200 characters
        }

        // Add the current element to the result array
        resultArray.push(arr[i])

        // Update the total character count
        totalChars += currentLength
    }

    return resultArray
}
